import { createSelector } from 'reselect'

export const selectToken = state => state.config.token
export const selectTimezone = state => state.config.timezone
export const selectReports = state => state.reports.reports
export const selectProfiles = state => state.profiles.profiles
export const selectProfilesVisibility = state => state.profiles.visible

export const selectVisibleProfiles = createSelector(
  selectProfiles,
  selectProfilesVisibility,
  (profiles, visibility) => profiles.filter(profile => visibility[profile])
)
export const selectProfileOptions = createSelector(
  selectProfiles,
  selectProfilesVisibility,
  (profiles, visibility) =>
    profiles.map(profile => ({
      value: profile,
      label: profile,
      selected: visibility[profile]
    }))
)
